import { ColDef, CellEditingStoppedEvent,  } from 'ag-grid-community';
import { Component, ViewChild  } from '@angular/core';
import appConfig from '../../../shared/config/app-config';
import { createColumn, createDateColumn } from '../../../utils/helper';
import { DatatableComponent } from '../../../shared/components/datatable/datatable.component';
import { SubscriptionService } from '../../../shared/services/subscription.service';
import { AuthService } from '../../../shared/services/auth.service';

@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrl: './setting.component.scss'
})
export class SettingComponent {

  @ViewChild(DatatableComponent) datatable!: DatatableComponent;

  url = `${appConfig.myAccountBaseUrl}setting`;

  user = this.authSerivice.currentUserValue
  colDefs: ColDef[] = [
    createColumn('Label', 'setting_label'),
    createColumn('Value', 'setting_value', {editable: true, cellEditor: 'agTextCellEditor', cellEditorParams: { maxLength: 10 }}),
    createDateColumn('Last activity', 'updated_at'),
  ];

  constructor(private subscriptionService: SubscriptionService, private authSerivice: AuthService) {}

  onCellValueChanged(event: CellEditingStoppedEvent): void {

    const payload = {
      setting_key: event.data.setting_key,
      setting_value: event.data.setting_value,
    };

    event.data = payload
    this.subscriptionService.confirmUpdate(event)
  }
}
